export const EVENT_DEFAULTS: Record<string, boolean> = {
	"order.paid": true,
	"order.partially_paid": true,
	"order.aml_rejected": true,
	"order.expired": false,
	"order.cancelled": false,
	"payment.success": true,
	"payment.failed": true,
	"payment.aml_rejected": true,
	"withdrawal.completed": true,
	"withdrawal.failed": true,
};

export const EVENT_LABELS: Record<string, string> = {
	"order.paid": "Order paid",
	"order.partially_paid": "Order partially paid",
	"order.aml_rejected": "Order rejected by AML",
	"order.expired": "Order expired",
	"order.cancelled": "Order cancelled",
	"payment.success": "Payment successful",
	"payment.failed": "Payment failed",
	"payment.aml_rejected": "Payment rejected by AML",
	"withdrawal.completed": "Withdrawal completed",
	"withdrawal.failed": "Withdrawal failed",
};

export const EVENT_GROUPS: { title: string; events: string[] }[] = [
	{
		title: "Orders",
		events: [
			"order.paid",
			"order.partially_paid",
			"order.aml_rejected",
			"order.expired",
			"order.cancelled",
		],
	},
	{
		title: "Payments",
		events: ["payment.success", "payment.failed", "payment.aml_rejected"],
	},
	{
		title: "Withdrawals",
		events: ["withdrawal.completed", "withdrawal.failed"],
	},
];

export function eventsEqual(
	a: Record<string, boolean>,
	b: Record<string, boolean>,
): boolean {
	const keys = new Set([...Object.keys(a), ...Object.keys(b)]);
	for (const k of keys) {
		if ((a[k] ?? false) !== (b[k] ?? false)) return false;
	}
	return true;
}
